import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const Show = () => {
  const [receiveData, setReceiveData] = useState({});
  const { id } = useParams();
  const [alert, setAlert] = useState(null);
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    setLoading(true);
    Http.get("/production/" + id)
      .then((res) => {
        setReceiveData(res.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Production Details</h5>
            <Link to="/production" className="btn btn-secondary">
              <i className="fa fa-arrow-left mg-r-6"></i>Back
            </Link>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              {loading ? (
                <div className="text-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 padding">
                  <div className="card">
                    <div className="card-body">
                      <div className="row mb-4">
                        <div className="col-sm-12">
                          <h5 className="mb-3">Production Information:</h5>
                          <div>
                            <strong>Date:</strong> {receiveData.date}
                          </div>
                          <div>
                            <strong>Time:</strong> {receiveData.time}
                          </div>
                          <div>
                            <strong>Finished Good:</strong>{" "}
                            {receiveData.product
                              ? receiveData.product.name
                              : ""}
                          </div>
                          <div>
                            <strong>Receipt No:</strong>{" "}
                            {receiveData.receipt_no}
                          </div>
                          <div>
                            <strong>Batch Size:</strong>{" "}
                            {receiveData.batch_size}
                          </div>
                          {/* <div>
                            <strong>Total Quantity:</strong> {receiveData.qty}
                          </div> */}
                          <div>
                            <strong>Created By:</strong>{" "}
                            {receiveData.created_by
                              ? receiveData.created_by.name
                              : ""}
                          </div>
                        </div>
                        {/* <div className="col-sm-6">
                          <div>
                            <strong>Batch Costing:</strong>{" "}
                            {receiveData.batch_costing || "N/A"}
                          </div>
                          <div>
                            <strong>Receive Status:</strong>{" "}
                            {receiveData.receive_status}
                          </div>
                          <div>
                            <strong>Receive Date:</strong>{" "}
                            {receiveData.receive_date || "N/A"}
                          </div>
                          <div>
                            <strong>Notes:</strong> {receiveData.notes || "N/A"}
                          </div>
                          <div>
                            <strong>Created By:</strong>{" "}
                            {receiveData.created_by
                              ? receiveData.created_by.name
                              : ""}
                          </div>
                        </div> */}
                      </div>

                      {receiveData.items && receiveData.items.length > 0 && (
                        <>
                          <h5 className="mb-3">RM &amp; PM Items Usages:</h5>
                          <div className="table-responsive-sm">
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th className="center">#</th>
                                  <th>Product</th>
                                  <th className="text-right">Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                {receiveData.items.map((item, index) => (
                                  <tr key={item.id}>
                                    <td className="center">{index + 1}</td>
                                    <td className="left strong">
                                      {item.product ? item.product.code : ""} - {item.product ? item.product.name : ""}
                                    </td>
                                    <td className="text-right">{item.qty}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}

                      <div className="row mt-4">
                        <div className="col-sm-12 text-center">
                          <Link
                            to={"/edit-production/" + id}
                            className="btn btn-primary mg-r-10"
                          >
                            <i className="fa fa-edit mg-r-6"></i>Edit
                          </Link>
                          <Link to="/production" className="btn btn-secondary">
                            <i className="fa fa-arrow-left mg-r-6"></i>Back to
                            List
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
